// Cross-subdomain cookie helper. We use this for the `nexus_locale` value
// so landing (nexusdijital.com) and dashboard (app.nexusdijital.com) share
// the user's last explicit language pick.
//
// Cookie attrs we always set:
//   Domain=.nexusdijital.com   — visible on every nexus subdomain
//   Path=/
//   Max-Age=31536000           — 1 year
//   SameSite=Lax               — works for top-level navigations
//   Secure                     — HTTPS only (both sites are HTTPS)
//   NOT HttpOnly               — JS on landing needs to read it without an API call
//
// In local dev we drop the Domain attribute so the cookie binds to the
// exact host (localhost / 127.0.0.1).

const ONE_YEAR_S = 60 * 60 * 24 * 365;

function isLocalHost(): boolean {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h.endsWith(".local");
}

export function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const prefix = encodeURIComponent(name) + "=";
  for (const part of document.cookie.split(";")) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      try {
        return decodeURIComponent(trimmed.slice(prefix.length));
      } catch {
        return null;
      }
    }
  }
  return null;
}

export function writeSharedCookie(name: string, value: string): void {
  if (typeof document === "undefined") return;
  const parts = [
    `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
    "Path=/",
    `Max-Age=${ONE_YEAR_S}`,
    "SameSite=Lax",
  ];
  if (!isLocalHost()) {
    parts.push("Domain=.nexusdijital.com");
    parts.push("Secure");
  }
  document.cookie = parts.join("; ");
}
